export function ajax(url, success, progress, type = "json") {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", url);
    // xmlHttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xmlHttp.responseType = type;
    xmlHttp.send();
    xmlHttp.onreadystatechange = function () {
        if (4 != this.readyState) return;
        if (200 != this.status) return;
        success(xmlHttp.response);  
    };

    // xmlHttp.addEventListener("loadend")

    if(progress)
    {
        xmlHttp.addEventListener("progress", progress);
    }    
}

let baseurl = "";
export function setBaseurl(url)
{
    baseurl = url;
}
export function Get(url,success)
{
    ajax(baseurl+url,success);
}

export function GetDis(data, success)
{
    var xmlHttp = new XMLHttpRequest();
    var d =serialize(data);
    // log("send:", d);.
    
    xmlHttp.open("GET", baseurl+"servlet/Dis?"+d);
    //xmlHttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xmlHttp.responseType = "json";
    xmlHttp.send(); // 不是post数据不能写在这
    xmlHttp.onreadystatechange = function () {
        if (4 != this.readyState) return;
        if (200 != this.status) return;
        // log("GetDis result:",xmlHttp.response);
        success(xmlHttp.response);  
    };
}
export function GetDisNoError(data, success)
{
    GetDis(data, par=>{
        if(par==null)
        {
            window.console.warn("服务器返回null");
            return;
        }
        if(par.errorInfo)
        {
            alert(par.errorInfo);
            return;
        }
        success(par);
    });
}




export function GetDisPromize(data)
{
    return new Promise(function(resolve) {
        GetDis(data, resolve);
    });
}

export function PostDis(data, success)
{
    var xmlHttp = new XMLHttpRequest();
    var d =serialize(data);
    // log("send:", d);
    xmlHttp.open("POST", "servlet/Dis");
    xmlHttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"); // post 这个一定要写
    xmlHttp.responseType = "json";
    xmlHttp.send(d+"&pwdsi=oqnJ9wKGWUw_gbr-JjYKZ4FkbjBI"); // 不是post数据不能写在这
    xmlHttp.onreadystatechange = function () {
        if (4 != this.readyState) return;
        if (200 != this.status) return;
        // log("GetDis result:",xmlHttp.response);
        success(xmlHttp.response);  
    };
}

export function UploadDis(formData, success)
{
    var xmlHttp = new XMLHttpRequest();
    // log("send:", d);
    xmlHttp.open("POST", baseurl+"servlet/UploadDis");
    // xmlHttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"); // post 这个一定要写
    xmlHttp.responseType = "json";
    xmlHttp.send(formData); // 不是post数据不能写在这
    xmlHttp.onreadystatechange = function () {
        if (4 != this.readyState) return;
        if (200 != this.status) return;
        // log("GetDis result:",xmlHttp.response);
        let par = xmlHttp.response;
        if(par==null)
        {
            return alert("服务器返回空");
        }
        if(par.errorInfo) {
            alert(par.errorInfo);
            return;
        }
        if(success) success(par);
    };
}



export function serialize (data) {
    let data_str = "";
    for(let k in data)
    {
        data_str += "&"+k+"="+encodeURIComponent(data[k]);
    }
    if(data_str.length>0)
    {
        data_str = data_str.substr(1);
    }
    return data_str;
}


function ajaxPost(url, data, success, progress, type = "json") {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("post", url);
    xmlHttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xmlHttp.responseType = type;

    xmlHttp.send(serialize(data));
    xmlHttp.onreadystatechange = function () {
        if (4 != this.readyState) return;
        if (200 != this.status) return;
        success(xmlHttp.response);  
    };

    // xmlHttp.addEventListener("loadend")

    if(progress)
    {
        xmlHttp.addEventListener("progress", progress);
    }    
}



export default ajax;

export {ajaxPost};
